import Crud from '../components/Holiday/Crud'
import Add from '../components/Holiday/Add'

let routes = {
    path: '/holidays',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/holidays',
            name: 'Feriados',
            component: Crud
        },
        {
            path: '/holiday/:id?',
            name: 'Feriado',
            component: Add
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/holidays.js